/*
 * @Author: 陈力恒
 * @LastEditors: 彭鑫诚
 * @Date: 2022-05-05 10:11:57
 * @LastEditTime: 2024-07-30 10:35:08
 * @Description: 要货单统计model
 */
import type {
  IRequestOrderStatisticsModel,
  IRequestOrderStatisticsStore,
} from '@monorepo/types/orders/requestOrderStatistics/requestOrderStatistics.types';
import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';
import moment from 'moment';

const initState: IRequestOrderStatisticsStore = {
  isInit: true,
  selectedOrderItem: [],
  orderTableList: [], // 明细
  orderTableTotal: 0,
  selectedTableItem: [],
  tableList: [], // 物品汇总
  total: 0,
  locationTableList: [], // 门店-物品汇总
  locationTableTotal: 0,
  query: {
    productPageSize: 50,
    productPage: 1,
    locationPageSize: 50,
    locationPage: 1,
    orderPageSize: 50,
    orderPage: 1,
    date_type: 'AUDIT_DATE',
    order_sort_order: 'USE_UNIT_QTY_DESC',
    location_sort_order: 'TOTAL_BASE_UNIT_QTY_DESC',
    product_sort_order: 'TOTAL_BASE_UNIT_QTY_DESC',
    date: getToday(),
    time: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
    query_type: 'PRODUCT',
    query_scope_type: 'SEARCH_NOT_FINISHED',
  },
  locationStatistics: {
    tot_location_qty: '0',
    not_request_location_qty: '0',
    request_location_qty: '0',
    not_request_location_list: [],
    request_location_list: [],
  },
  order_count: 0,
  product_count: 0,
  total_money: 0,
  all_total_base_unit_qty: 0,
  all_total_use_unit_qty: 0,
};

const requestOrderStatisticsStore: IRequestOrderStatisticsModel = {
  namespace: 'requestOrderStatisticsStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default requestOrderStatisticsStore;
